<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="like-solid-blue" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M1,8.4 C1,4 4.5,3 6.5,3 C9,3 11,5 12,6.5 C13,5 15,3 17.5,3 C19.5,3 23,4 23,8.4 C23,15 12,21 12,21 C12,21 1,15 1,8.4 Z" id="Shape" stroke="#39B8EB" stroke-width="1.5" fill="#39B8EB"></path>
        </g>
    </svg>
</template>
<script>
export default {
    name: 'icon-like',
};
</script>
<style>

</style>
